/* assets/rolex-consent.js
 * --------------------------------------------------------------------------
 * Consenso (CMP / GDPR) per la sezione Rolex Bespoke — banner NATIVO Shopify.
 *
 * Cookie richiesti dalle linee guida Rolex:
 *   rlx-consent    -> categoria Statistics/Performance (Adobe Analytics)
 *   rlx-marketing  -> categoria Marketing/Targeting
 * Il default "false" e' impostato inline da snippets/rolex-consent-init.liquid,
 * nel <head> PRIMA di Adobe Launch. Qui ci agganciamo alla Customer Privacy API
 * di Shopify per portarli a "true"/"false" secondo la scelta dell'utente.
 *
 * Il banner nativo Shopify da solo NON blocca Adobe Launch: e' questo ponte
 * cookie -> Launch che applica il consenso ad Adobe (Launch e' configurato
 * lato Rolex per leggere rlx-consent / rlx-marketing).
 */
(function () {
  'use strict';

  function setCookie(name, value) {
    document.cookie = name + '=' + value + ';path=/;SameSite=Lax';
  }

  function applyConsent(statistics, marketing) {
    setCookie('rlx-consent',   statistics ? 'true' : 'false');
    setCookie('rlx-marketing', marketing  ? 'true' : 'false');
  }

  // API manuale (utile per i test o per un eventuale CMP esterno futuro).
  window.rolexConsent = {
    set: function (o) { o = o || {}; applyConsent(o.statistics === true, o.marketing === true); },
    accept:  function () { applyConsent(true, true); },
    decline: function () { applyConsent(false, false); }
  };

  // --- Integrazione con il banner nativo Shopify (Customer Privacy API) ---

  // Allinea i cookie allo stato CORRENTE: serve per i visitatori di ritorno,
  // perche' l'evento visitorConsentCollected non si rilancia al caricamento.
  function syncFromShopify() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    var stats = false, mkt = false;
    try { stats = cp.analyticsProcessingAllowed(); } catch (e) {}
    try { mkt   = cp.marketingAllowed(); } catch (e) {}
    applyConsent(stats === true, mkt === true);
  }

  // L'API si carica in modo asincrono: la aspettiamo prima di leggerla.
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) syncFromShopify();
    });
  } else {
    window.addEventListener('load', syncFromShopify);
  }

  // Reagisce alle scelte / cambi di consenso durante la visita.
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    applyConsent(d.analyticsAllowed === true, d.marketingAllowed === true);
  });
})();
